import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import {
  FiChevronRight,
  FiHome,
  FiUser,
  FiMail,
  FiCreditCard,
  FiLoader,
  FiAlertCircle,
  FiSave,
} from "react-icons/fi";

import toast from "react-hot-toast";

import { updateProfile } from "../../store/slices/profile";

const EditProfile = () => {

  const dispatch = useDispatch();

  const {
    profilelist,
    loading,
    error,
  } = useSelector((state) => state.profile);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [walletAddress, setWalletAddress] = useState("");

  const [validationError, setValidationError] = useState("");

  /* ================= PROFILE DATA ================= */

  useEffect(() => {

    if (!profilelist) return;

    console.log("PROFILE DATA:", profilelist);

    setName(profilelist?.name || "");
    setEmail(profilelist?.email || "");
    setWalletAddress(profilelist?.walletAddress || "");

  }, [profilelist]);


  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {

    e.preventDefault();

    setValidationError("");

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedWalletAddress = walletAddress.trim();


    /* ================= NAME VALIDATION ================= */

    if (!trimmedName) {

      setValidationError("Please enter your name.");

      return;

    }


    /* ================= EMAIL VALIDATION ================= */

    if (!trimmedEmail) {

      setValidationError("Please enter your email.");

      return;

    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmedEmail)) {

      setValidationError("Please enter a valid email address.");

      return;

    }


    /* ================= PAYLOAD ================= */

    const payload = {

      name: trimmedName,

      email: trimmedEmail,

      // Wallet address is OPTIONAL
      walletAddress: trimmedWalletAddress,

    };

    console.log(
      "UPDATE PROFILE PAYLOAD:",
      payload
    );


    /* ================= API ================= */

    try {

      await dispatch(
        updateProfile(payload)
      ).unwrap();

      toast.success(
        "Profile updated successfully"
      );

    } catch (err) {

      console.error(
        "UPDATE PROFILE ERROR:",
        err
      );

      toast.error(
        typeof err === "string"
          ? err
          : err?.message ||
          "Failed to update profile"
      );

    }

  };


  const errorMessage =
    validationError || error;


  return (

    <div className="gi-referral-page">

      {/* ================= BREADCRUMB ================= */}

      <div className="gi-breadcrumb">

        <Link to="/dashboard">

          <FiHome />

          Dashboard

        </Link>

        <FiChevronRight
          className="gi-breadcrumb-arrow"
        />

        <span>
          Settings
        </span>

        <FiChevronRight
          className="gi-breadcrumb-arrow"
        />

        <span>
          Edit Profile
        </span>

      </div>


      {/* ================= FORM ================= */}

      <section className="gi-transfer-card">

        {loading && !profilelist ? (

          <div className="gi-table-message">

            <FiLoader
              className="gi-transfer-spinner"
            />

            Loading profile...

          </div>

        ) : (

          <form
            onSubmit={handleSubmit}
            className="gi-transfer-form"
          >

            {/* ================= NAME ================= */}

            <div className="gi-transfer-form-group">

              <label htmlFor="name">

                Name
                <span>*</span>

              </label>

              <div className="gi-transfer-input-wrapper">

                <FiUser />

                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => {

                    setName(e.target.value);
                    setValidationError("");

                  }}
                  placeholder="Enter your name"
                  className="gi-transfer-input"
                  disabled={loading}
                  autoComplete="name"
                />

              </div>

            </div>


            {/* ================= EMAIL ================= */}

            <div className="gi-transfer-form-group">

              <label htmlFor="email">

                Email
                <span>*</span>

              </label>

              <div className="gi-transfer-input-wrapper">

                <FiMail />

                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => {

                    setEmail(e.target.value);
                    setValidationError("");

                  }}
                  placeholder="Enter your email"
                  className="gi-transfer-input"
                  disabled={loading}
                  autoComplete="email"
                />

              </div>

            </div>


            {/* ================= WALLET ADDRESS ================= */}

            <div className="gi-transfer-form-group">

              <label htmlFor="walletAddress">
                Wallet Address
              </label>

              <div className="gi-transfer-input-wrapper">

                <FiCreditCard />

                <input
                  id="walletAddress"
                  type="text"
                  value={walletAddress}
                  onChange={(e) => {

                    setWalletAddress(
                      e.target.value
                    );

                    setValidationError("");

                  }}
                  placeholder="Enter your wallet address"
                  className="gi-transfer-input"
                  disabled={loading}
                  autoComplete="off"
                />

              </div>

              <small>
                Wallet address is optional.
              </small>

            </div>


            {/* ================= ERROR ================= */}

            {errorMessage && (

              <div className="gi-transfer-error">

                <FiAlertCircle />

                <span>
                  {errorMessage}
                </span>

              </div>

            )}


            {/* ================= SUBMIT ================= */}

            <button
              type="submit"
              className="gi-transfer-submit"
              disabled={loading}
            >

              {loading ? (

                <>
                  <FiLoader
                    className="gi-transfer-spinner"
                  />

                  Updating...
                </>

              ) : (

                <>
                  <FiSave />

                  Update Profile
                </>

              )}

            </button>

          </form>

        )}

      </section>

    </div>

  );

};

export default EditProfile;